class CookieScripts {
    constructor(){
        this.insertCookiesToLinks();
    }
    insertCookiesToLinks(){
        const cookieNameArr = ['gclid'];
        const allLinks = $('a[href*="/"]');
        const thisClass = this;
        let searchParams = new URLSearchParams(window.location.search);
        let createLink = "";

        cookieNameArr.forEach(element => {
            const getParameter = searchParams.get(element)
            if(getParameter !== null && getParameter !== ""){
                thisClass.setCookie(element,getParameter,365);
            }
        });

        cookieNameArr.forEach(element => {
            const getParameter = thisClass.getCookie(element);
            if(getParameter !== null && getParameter !== ""){
                createLink += '&'+element+'='+getParameter;
            }
        });

        if(createLink !== null && createLink !== ""){
            createLink = createLink.substring(1);
            allLinks.each(function(){
                const $this = $(this);
                const _href = $this.attr("href");
                //if href contains parameters
                if (this.href.indexOf('?') !== -1) {
                    $this.attr("href", _href + '&'+createLink);
                }else{
                    $this.attr("href", _href + '?'+createLink);
                }
            });
        }
    }
    getCookie(cname) {
        const name = cname + "=";
        const ca = document.cookie.split(';');
        for(let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }
    setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        const expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }
}

// On document ready
KTUtil.onDOMContentLoaded(function() {
    new CookieScripts();
});